<template>
  <v-dialog
    content-class=""
    v-model="isDialog"
    light
    fullscreen
  >
    <v-card v-if="isDialog">
      <div class="thisDialog text-center" style="min-height: var(--layout-height)">
        <div class="d-inline-block">

          <template>
            <div class="hidden-sm-and-up">
              <h4 class="pt-2">Deine Tischummer?</h4>
              <div>(siehe Nummer auf dem Tisch)</div>
            </div>
            <h3 class="pt-2 hidden-xs-only">Bitte gib deine Tischummer ein:</h3>
            <!--            <h2 v-if="options.html" class="dg-title" v-html="messageTitle"></h2>-->
            <!--            <h2 v-else class="dg-title">{{ messageTitle }}</h2>-->
          </template>

          <div class="spacer-15"></div>
          <div class="d-inline-block">
            <table class="table-collapse ntable">
              <tr>
                <td>
                  <div class="num noselect" @click.passive="clickNum('1')">
                    <div class="superCenter">1</div>
                  </div>
                </td>
                <td>
                  <div class="num noselect" @click.passive="clickNum('2')">
                    <div class="superCenter">2</div>
                  </div>
                </td>
                <td>
                  <div class="num noselect" @click.passive="clickNum('3')">
                    <div class="superCenter">3</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="num noselect" @click.passive="clickNum('4')">
                    <div class="superCenter">4</div>
                  </div>
                </td>
                <td>
                  <div class="num noselect" @click.passive="clickNum('5')">
                    <div class="superCenter">5</div>
                  </div>
                </td>
                <td>
                  <div class="num noselect" @click.passive="clickNum('6')">
                    <div class="superCenter">6</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="num noselect" @click.passive="clickNum('7')">
                    <div class="superCenter">7</div>
                  </div>
                </td>
                <td>
                  <div class="num noselect" @click.passive="clickNum('8')">
                    <div class="superCenter">8</div>
                  </div>
                </td>
                <td>
                  <div class="num noselect" @click.passive="clickNum('9')">
                    <div class="superCenter">9</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="num noselect" @click.passive="clickNum('0')">
                    <div class="superCenter">0</div>
                  </div>
                </td>
                <td colspan="2">
                  <div class="num noselect" style="width: 100%;" @click.passive="reset">
                    <div class="superCenter">RESET</div>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <div class="mt-3 mb-3">
            <div class="displayTischnummer d-inline-block" v-html="num"></div>
          </div>

          <div class="text-center">
            <v-btn class="text-none btn-df mr-4 ml-2 mt-7"
                   @click.native.passive.stop="goAhead">
              Weiter
            </v-btn>
          </div>
          <div class="text-center">
            <v-btn class="text-none btn-df mt-7" @click.native.passive.stop="handleDismiss">
              Abbrechen
            </v-btn>
          </div>

        </div>
        <div class="pb-3"></div>

      </div>
    </v-card>


  </v-dialog>
</template>


<script>
import {ebus} from '../vendor/ebus';

export default {
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      isDialog: false,

      num: '&nbsp;'
    }
  },
  watch: {
    dialog(newValue) {
      this.isDialog = newValue;
      if (newValue) {
        //init
        this.num = '&nbsp;';
      }
    },
    isDialog(newValue) {
      if (!newValue) {
        // this.ready = false;
        this.$emit('close');
      }
    }
  },
  mounted() {
    this.reset();
  },
  methods: {
    clickNum(_num) {
      if (this.num === '&nbsp;') {
        this.num = _num;
      } else if (this.num.length < 3) {
        this.num += _num;
      }
    },
    reset() {
      this.num = '&nbsp;';
    },
    closeDialog() {
      this.isDialog = false;
      // this.$emit('close');//no
    },
    goAhead() {
      if (this.num === '&nbsp;' || this.num.length < 1) {
        ebus.$emit('showInfo', {
          title: 'Bitte gib deine Tischmummer ein, oder drücke auf den Button "Abbrechen"',
          text: ''
        });
      } else {
        this.$emit('tnumberselected', '' + this.num);
        this.closeDialog();
      }

    },
    handleDismiss() {
      this.closeDialog();
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/base';

.thisDialog {
  /*<!--background-color: rgba($color-primary, 0.95);-->*/


  /*position: fixed;*/
  /*z-index: 180;*/
  /*top: 0;*/
  /*left: 0;*/
  /*height: 100%;*/
  /*width: 100%;*/
}

.ntable {
  td {
    width: 33.33%;
    text-align: center;
    padding: 8px;
  }
}

.num {
  display: inline-block;
  background-color: $accent;
  @include text-contrast($accent);
  font-size: 2em;
  border-radius: 8px;
  width: 70px;
  height: 70px;
  padding: 8px;


  @include material-shadow(2);
}

.displayTischnummer {
  font-size: 3.5rem;
  font-weight: bold;
  color: black;
  min-width: 100px;
  border-bottom: 1px solid black;
  /*height: 73px;*/
}

.vdevice-xs {
  .ntable {
    td {
      padding: 6px;
    }
  }

  .num {
    font-size: 1.8em;
    width: 60px;
    height: 60px;
  }

  .displayTischnummer {
    font-size: 2.6rem;
  }
}

/*.vvd{*/
/*    >>> .v-dialog{*/
/*        position: absolute;*/
/*    }*/
/*}*/

</style>
